import Popover from './Popover'
import { usePopover } from './usePopover'

Popover.usePopover = usePopover
export default Popover
